import { call, put, takeEvery } from "redux-saga/effects";
// actions
import { experienceInfoSuccess, experienceInfoFailure } from "../../../actions/Workforce/EmployeeDetils/ExperienceInfo";
// constant
import { EXPERIENCE_INFO } from "../../../constants/Workforce/EmployeeDetils/ExperienceInfo";
// request type
import getRequest from "../../../../util/APIHelperGet";
import { baseUrl } from "../../../../util/APIBaseUrl";

export const fetchExperienceInfoRequest = async (actions) => {
  return await getRequest(`${baseUrl}/${actions.payload.request}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchExperienceInfo(params) {
  try {
    const response = yield call(fetchExperienceInfoRequest, params);
    yield put(experienceInfoSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(experienceInfoFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(EXPERIENCE_INFO, fetchExperienceInfo);
}
